import { LCObTokens } from '../LC/LC.obTokens';

export const FEObTokens = {
  ...LCObTokens,
  text2xlFamily: 'Poppins',
  text3xlFamily: 'Poppins',
  text4xlFamily: 'Poppins',
  text5xlFamily: 'Poppins',
  text6xlFamily: 'Poppins',
  text7xlFamily: 'Poppins',
  textCTABigFamily: 'Poppins',
  textCTAMediumFamily: 'Poppins',
  textCTASmallFamily: 'Poppins',
  textBaseFamily: 'Poppins',
  textH1Family: 'Poppins',
  textH2Family: 'Poppins',
  textH3Family: 'Poppins',
  textH4Family: 'Poppins',
  textH5Family: 'Poppins',
  textH6Family: 'Poppins',
  textLgFamily: 'Poppins',
  textSmFamily: 'Poppins',
  textXlFamily: 'Poppins',
  textXsFamily: 'Poppins',
  // LuxButton primary background/border - scrollbar thumb
  actionColorBgBrand: 'rgba(0, 90, 187, 1)',
  // LuxButton primary hover/pressed - LuxCheckbox hover
  actionColorBgBrandHover: 'rgba(0, 72, 150, 1)',
  // LuxButton secondary border
  actionColorBordersTertiary: 'rgba(0, 90, 187, 1)',
  // LuxButton secondary/ghost text and icons
  actionColorTextLinkTertiary: 'rgba(0, 90, 187, 1)',
  // Selected LuxTimeSlot, LuxTabs, LuxCheckbox and LuxToggle background
  bgColorBrandPrimary: 'rgba(0, 90, 187, 1)',
  // Selected LuxToggle and cards border
  bordersColorBrandPrimary: 'rgba(0, 90, 187, 1)',
};
